import { useQueryClient } from '@tanstack/react-query';
import { http } from 'services/http';
import { ADDITIONAL_COSTS_GET_MANY, ORDER_GET_ONE } from 'api/query-keys';
import type { TCreateAdditionalCostReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useAddAdditionalCost = () => {
  const queryClient = useQueryClient();
  return useMutationBase<unknown, unknown, TCreateAdditionalCostReq>({
    mutationFn: async (variables) => {
      await http.post<TCreateAdditionalCostReq>('/v1/additional-costs', variables);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [ADDITIONAL_COSTS_GET_MANY, String(variables.orderId)] });
      queryClient.invalidateQueries({ queryKey: [ORDER_GET_ONE, variables.orderId] });
    },
  });
};
